import ReactDOM from 'react-dom';
import React, { PureComponent } from 'react';
import './index.less';

class Roger extends PureComponent {
  state = {
    canClick: true,
    seconds: 5,
    timer: true,
  };

  componentWillUnmount = () => {
    this.props.callback();
  };

  componentDidMount() {
    this.settimer();
  }

  settimer = () => {
    this.settimer = setInterval(() => {
      this.setState(
        preState => ({ seconds: preState.seconds - 1 }),
        () => {
          if (this.state.seconds === 0) {
            clearInterval(this.settimer);
            const div = document.getElementsByClassName('container')[0]
              .children[1];
            ReactDOM.unmountComponentAtNode(div);
            div.parentNode.removeChild(div);
          }
        }
      );
    }, 1000);
  };

  onClick = () => {
    this.props.click();
  };

  render() {
    const { className, text,lang } = this.props;
    const { seconds, timer } = this.state;
    return (
      <div className="roger_btn">
        <button className={`roger ${className || ''}`} onClick={this.onClick}>
          {text || lang.Understood} {timer ? `${seconds}s` : ''}
        </button>
      </div>
    );
  }
}

Roger.defaultProps = {
  click: () => {},
  callback: () => {},
};

export default Roger;



// WEBPACK FOOTER //
// ./src/components/Roger/index.js